import React from 'react'

function ActiveChatsComponent({ activeChat, removeUserById }) {
    return (
        <div style={{
            'width': '300px',
            'height': '400px',
            'margin': '0 2px',
            'backgroundColor': '#fff',
            'display': 'flex',
            'border': '1px solid #0e1724',
            'flexDirection': 'column',
            'alignItems': 'flex-start'
        }}>
            <div style={{
                'padding': '10px 20px',
                'backgroundColor': '#0e1724',
                'color': '#fff',
                'width': '100%'
            }}>
                {`${activeChat.opName}`}
                <button
                    style={{
                        justifyItems: "flex-end",
                        border: "none",
                        background: "none",
                    }}
                    onClick={() => removeUserById(activeChat.op)}
                >
                    <i className="fas fa-times-circle has-text-danger"></i>
                </button>
            </div>
            <div style={{ 'padding': '10px 20px' }}>
                <p>The align-items property, set on the flex container, and the align-self property, set on flex items, control the alignment of flex items on the cross axis. The cross axis runs down the columns if flex-direction is row and along the rows if flex-direction is column.</p>
            </div>
            <div>
                <input type='text' />
                <button
                    style={{
                        justifyItems: "flex-end",
                        border: "none",
                        background: "none",
                    }}
                ><i className='fas fa-paper-plane' style={{ color: '#ff7b29' }}></i></button>
            </div>
        </div>
    )
}

export default ActiveChatsComponent;